import { observer } from 'mobx-react';
import { autoinject, inject, NotificationList, Topbar } from 'Mri.Web.Common';
import * as React from 'react';
import { AppStore } from './AppStore';
import { UserMenu } from './UserMenu';

export interface IHeaderProps {
    readonly onMenuLinkClick: any;
    readonly history: any; // Hack to get component to rerender on location change
}

@autoinject
@observer
export class Header extends React.Component<IHeaderProps> {
    public render() {
        return (
            <Topbar onMenuLinkClick={this.props.onMenuLinkClick} hide={this.appStore.hiddenHeader}>
                <div className="py-0 ms-auto d-flex">
                    <NotificationList />
                    <UserMenu />
                </div>
            </Topbar>
        );
    }

    @inject
    private appStore!: AppStore;
}
